import { useState, useEffect } from 'preact/compat';
import { createPortal } from 'preact/compat';
import ProductSlider from "@/components/ProductSlider";
import useLocalStorageState from "use-local-storage-state";

function TabbedProductSlider({ settings }) {
	const [retailerObj, setRetailerObj] = useLocalStorageState("dutchie_retailer",null);
	const retailerId = retailerObj?.id;
	const retailer = dutchie.retailers.find(
		(location) => location.id === retailerObj?.id
	);

	const { index, tabs } = settings;
	const [activeTab, setActiveTab] = useState(0);
	const target = document.querySelector(`#tabbed-slider-component-root-${index}`);
	const module = document.querySelector(`#module-${index}`);

	const activeTabSettings = {
		...settings,
		category: tabs[activeTab].tab_category,
	};

	if ( ! target ) {
		return null;
	}
	
	return createPortal(
		<div className="tabbed-product-slider-contents">
			<div className="tabbed-product-slider-tabs">
				{tabs && tabs.length > 0 && tabs.map((tab, index) => (
					<button
						onClick={() => setActiveTab(index)} 
						className={`btn-reset btn-tab ${activeTab === index ? 'active' : ''}`}
						key={tab.tab_name}
					>
						{tab.tab_name}
					</button>
				))}
			</div>

			<ProductSlider settings={activeTabSettings} />
		</div>,
		target
	)
}
export default TabbedProductSlider;